export var STATUS;

!function(STATUS) {
    STATUS[STATUS.INITIAL = 0] = "INITIAL", STATUS[STATUS.RUNNING = 1] = "RUNNING", 
    STATUS[STATUS.PAUSE = 2] = "PAUSE";
}(STATUS || (STATUS = {}));
//# sourceMappingURL=ticker.js.map
